import { render, staticRenderFns } from "./PopoverItem.vue?vue&type=template&id=6ac1f54a&scoped=true"
import script from "./PopoverItem.vue?vue&type=script&lang=js"
export * from "./PopoverItem.vue?vue&type=script&lang=js"
import style0 from "./PopoverItem.vue?vue&type=style&index=0&id=6ac1f54a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1f54a",
  null
  
)

export default component.exports